module.exports = __webpack_public_path__ + "img/202509_03.c6600b9c.jpg";